import { Images } from 'assets/images';
import { StyledNoFoundPage } from './styled';

export const NotFound = () => (
  <StyledNoFoundPage>
    <p className="title">Error</p>
    <img src={Images.notFound} alt="notFound" />
    <p className="notFound">page Not found</p>
  </StyledNoFoundPage>
);
